import SePlainAlertDialog from './SePlainAlertDialog';

export const seConfirm = async (text: string, choices?: string[]) => {
    const dialog = new SePlainAlertDialog();
    dialog.textContent = text;
    dialog.choices = choices ?? ['Ok', 'Cancel'];
    dialog.open();
    const response = await dialog.whenClosed();
    return response.choice;
};

window.seConfirm = seConfirm;

declare global {
    interface Window {
        seConfirm(text: string, choices?: string[]): Promise<string>;
    }
}
